module.exports = __webpack_public_path__ + "img/rancher-logo.0768c792.svg";